import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import table from './assets/images/table.jpg';


const PhpLesson15 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `

        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>Create a Table</strong></h3>
       <p>A table in a database is a collection of data that is organized into rows and columns.</p>
       <p>Each row represents a single record, and each column represents a field or attribute of that record. Tables are used to store and manage data in a structured and organized way.</p>
       <p>To create a table in PhpMyAdmin, we can follow any of these two approaches:</p>
       <p><b>1. Using <span class="text-danger">SQL</span> statments.</b></p>
       <p><b>2. Using the graphical user interface.</b></p>

       <p>We shall explore how to create a table using these two (2) approaches.</p>

       <h4>1. Using SQL Statements</h4>
       <p><b>1. Log in to phpMyAdmin and select the database where you want to create the table.</b></p>
       <p><b>2. Click on the "SQL" tab.</b></p>
       <p><b>3. Type the SQL statement for creating the table. The basic syntax for creating a table is:
        <span class="text-danger">CREATE TABLE table_name (column_name data_type constraint, ...);</span></b></p>
        <p><b>4. Press the "Go" button to create the table.</b></p>
        <p>Example</p>
    <pre className="text-danger">
CREATE TABLE employees (
id INT PRIMARY KEY AUTO_INCREMENT,
name VARCHAR(255) NOT NULL,
email VARCHAR(255) NOT NULL,
salary DECIMAL(10, 2) NOT NULL
);
    </pre>

    <p>This creates a table called <b>"employees"</b> with 4 columns: <b>"id"</b>, <b>"name"</b>, <b>"email"</b>, and <b>"salary"</b>. The <b>"id"</b> column is set as the primary key and auto-increment, <b>"name"</b> and <b>"email"</b> are set as not null and <b>"salary"</b> as decimal with 2 decimal points.</p>
        <h4>2. Using GUI</h4>
        <p>To use the <b>"Create table"</b> feature in the <b>"Structure"</b> tab to create a table with a graphical interface in phpMyAdmin, follow these steps:</p>
        <p>1. Log in to phpMyAdmin and select the database where you want to create the table.</p>
        <p>2. Click on the "Structure" tab.</p>
        <p>3. Click on the "Create table" button.</p>
        <p>4. In the "Create table" form, enter the name of the table and the number of columns you want to create.</p>

        <p>5. For each column, enter the name, data type, and any other attributes you want to set. You can also set the primary key, indexes and auto-increment.</p>
        <p>6. Once you have entered all the information for the columns, click on the "Save" button to create the table.</p>
        <img src={table} alt="create table" class="img-fluid" />







    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson15
